import { WarningIcons } from './warning-icons.enum';

export interface WarningDialogueInterface {
  title: string
  message: string
  confirm: string
  cancel: string
  icon: WarningIcons
  image: string
}

export class WarningDialogue implements WarningDialogueInterface {

  constructor(

    public title = 'Are sure you wish to do this?',
    public message = 'By Continuing, you will be deleting this message',
    public confirm = 'Continue',
    public cancel = 'Cancel',
    public icon = WarningIcons.ANNOUNCE,
    public image = ''

  ) {}

  static adapt(item: any): WarningDialogue {

    return new WarningDialogue(
      item.title,
      item.message,
      item.confirm,
      item.cancel,
      item.icon,
      item.image,
    )

  }
}
